import * as React from 'react';
import { Head } from '@inertiajs/react';
import type { BarrioInfo } from '../../types/barrios-landing';

interface BarrioSEOProps {
  barrio: BarrioInfo;
  appUrl: string;
}

export function BarrioSEO({ barrio, appUrl }: BarrioSEOProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Abasto Virtual',
    description: `Delivery de frutas y verduras frescas en ${barrio.name}, ${barrio.city}. Selección diaria del Mercado de Abasto con entrega programada.`,
    url: `${appUrl}/barrios-privados/${barrio.slug}`,
    telephone: '+5493512026384',
    address: {
      '@type': 'PostalAddress',
      addressLocality: barrio.city,
      addressRegion: 'Córdoba',
      addressCountry: 'AR',
    },
    areaServed: {
      '@type': 'Place',
      name: barrio.name,
      geo: {
        '@type': 'GeoCoordinates',
        latitude: barrio.lat,
        longitude: barrio.lon,
      },
    },
    priceRange: '$$',
  };

  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Head>
      <section className="bs-seo">
        <style>{`
          .bs-seo {
            padding: 48px 24px;
            background: #fafaf7;
            border-top: 1px solid #eee;
          }
          .bs-seo-inner {
            max-width: 720px;
            margin: 0 auto;
          }
          .bs-seo h2 {
            font-size: 20px;
            font-weight: 700;
            color: #666;
            margin: 0 0 12px;
          }
          .bs-seo p {
            font-size: 15px;
            color: #888;
            line-height: 1.7;
            margin: 0 0 12px;
          }
          .bs-seo p:last-child {
            margin-bottom: 0;
          }
        `}</style>
        <div className="bs-seo-inner">
          <h2>Verdulería a domicilio en {barrio.name}</h2>
          <p>
            Abasto Virtual entrega frutas y verduras frescas en {barrio.name}, {barrio.city}.
            Selección diaria del Mercado de Abasto, entrega programada, y coordinación con la guardia
            de seguridad de tu barrio. Pedí online desde el celular y recibí en la puerta de tu casa.
          </p>
          <p>
            Comprá frutas y verduras de calidad sin salir de {barrio.name}. Productos frescos,
            precios de mercado y delivery hasta tu domicilio.
          </p>
        </div>
      </section>
    </>
  );
}
